import t from "./ghl-ui.es1291.js";
import o from "./ghl-ui.es1292.js";
function p(r) {
  return o(t(r).toLowerCase());
}
export {
  p as default
};
